<template>
  <header class="header">

    <nav class="nav">
      <ul>
        <li v-for="(link, index) in navLinks" :key="index">
          <router-link :to="link.url">
            {{ link.name }}
          </router-link>
        </li>
      </ul>
    </nav>

  </header>
</template>

<script>
export default {
  name: 'page-header',
  props: {
    siteName: {
      type: String,
      required: true
    },
    navLinks: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
